// ============================================================
// TargetFrame - the target panel's livery (v8.244.0).
//
// Four danger-red corner brackets around the map cell. Pure decoration:
// pointer-events none throughout, so the sights, the numerals and the
// right-click armour underneath never notice it. Only the TARGET panel
// wears it - the actor and target tabs stop being symmetrical, which is
// the point. The TARGET LOCK stencil it carried while a called shot was
// engaged is gone (ADR 2026-10-11): the lock is the bracket on the plate.
// ============================================================
import styles from '../styles/TargetFrame.module.css';

export default function TargetFrame() {
  return (
    <div className={styles.frame} data-testid="target-frame" aria-hidden="true">
      <span className={styles.corner} data-corner="tl" />
      <span className={styles.corner} data-corner="tr" />
      <span className={styles.corner} data-corner="bl" />
      <span className={styles.corner} data-corner="br" />
    </div>
  );
}
